import TRANSLATION_EN_US from '../translation/en_us.json';
import TRANSLATION_DE_DE from '../translation/de_de.json';
import TRANSLATION_FR_FR from '../translation/fr_fr.json';
import TRANSLATION_MAPPING from '../translation/mapping.json';

class GlobalData {
  constructor() {
    this.popped = false;
    this.locale = 'en';
    this.language = 'en_us';
    this.urlRegion = '';
    this.chatLangCode = 'en-us';
    this.translatedStrings = TRANSLATION_EN_US;
    this.maxMessageLength = 2008;
  }

  setPopped = (state) => {
    this.popped = state;
  }

  isPopped = () => this.popped;

  setLocaleData(language) {
    if (language) {
      const split = language.split('_');
      this.locale = split[0].toLowerCase() || language.toLowerCase();
      this.language = language.toLowerCase();

      const region = split[1].toLowerCase();
      if (region !== 'us') {
        this.urlRegion = `_${region}`;
      }
    }

    switch (this.language.toLowerCase()) {
      case 'en_us':
        this.translatedStrings = TRANSLATION_EN_US;
        break;
      case 'fr_fr':
        this.translatedStrings = TRANSLATION_FR_FR;
        break;
      case 'de_de':
        this.translatedStrings = TRANSLATION_DE_DE;
        break;
      default: // defaults to en_US
        this.translatedStrings = TRANSLATION_EN_US;
        this.locale = 'en';
        this.language = 'en_us';
    }

    this.chatLangCode = TRANSLATION_MAPPING.architectflow[this.language] || 'en-us';
  }
}

export default new GlobalData();
